import { create } from "zustand";
export const useModal = create((set)=>({
        isOpen: false,
        returnValue: undefined,
        open: ()=>set({
                isOpen: true
            }),
        close: ()=>set({
                isOpen: false
            }),
        setReturnValue: (returnValue)=>set({
                returnValue
            })
    }));
